import React from 'react';

import { validServiceType } from '~support-at-home/lib/derive';

import { TooltipPortal } from '~components';
import { Row } from '~components/table-view';

import { ServiceTypeRow } from '~appointments/reducers/serviceTypes';

interface ComponentProps {
  row: Row;
  serviceTypes: ServiceTypeRow[];
}

const ReadOnlyService: React.FC<ComponentProps> = ({ row, serviceTypes }) => {
  const serviceType = validServiceType(row, serviceTypes);
  if (serviceType) {
    return <div className="p-1">{serviceType.name}</div>;
  } else {
    return (
      <>
        <TooltipPortal targetId={`${row.id}-missing-service`} content="Service deleted or not found." />
        <div className="missing-cell" id={`${row.id}-missing-service`}>
          DELETED
        </div>
      </>
    );
  }
};

export default ReadOnlyService;
